// src/config/auth-config.js
// Authentication Configuration for Web (Google + Phone Auth Focus)

export const AUTH_CONFIG = {
  // Keep session for 30 days after login (Firebase handles actual token refresh)
  // Set to null for "remember forever" until explicit logout
  PERSISTENCE_DAYS: 30,

  // Phone auth settings (used if you have phone login flow)
  PHONE_TIMEOUT_SECONDS: 60,
  PHONE_RESEND_COOLDOWN_MS: 30000, // 30 seconds

  // API endpoints used in Google auth flow
  API_ENDPOINTS: {
    VERIFY_TOKEN: '/api/auth/verify-token',
    PROFILE: '/api/users/me',
    CART_MERGE: '/api/cart/merge',
  },

  // Enable debug logging in development
  DEBUG_AUTH: process.env.NODE_ENV === 'development',
};

// Helper: Convert persistence days to milliseconds
export const getAuthExpirationTime = () => {
  if (!AUTH_CONFIG.PERSISTENCE_DAYS) return null;
  return AUTH_CONFIG.PERSISTENCE_DAYS * 24 * 60 * 60 * 1000;
};

// Format Indian phone numbers consistently
export const formatPhoneForIndia = (raw) => {
  if (!raw) return '';
  const trimmed = raw.trim().replace(/\s/g, '');
  
  if (trimmed.startsWith('+91')) return trimmed;
  if (trimmed.startsWith('0')) return '+91' + trimmed.substring(1);
  if (trimmed.length === 10 && /^\d{10}$/.test(trimmed)) return '+91' + trimmed;
  
  return trimmed; // fallback
};

// Simple email validation (useful for future or validation)
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Debug logger
export const shouldLogDebug = (message, ...args) => {
  if (AUTH_CONFIG.DEBUG_AUTH) {
    console.log(`%c[AUTH] ${message}`, 'color: #6366f1; font-weight: bold', ...args);
  }
};